//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isProductType } from '@motionelements/core/src/services/catalog.service.js';
import ElementCardAudioLoader from '@motionelements/core/src/components/product/ElementCardAudioLoader.vue';

export default {
  name: 'ElementsPreloader',
  components: {
    ElementCardAudioLoader,
    ProductCardLoader: () => import('@motionelements/core/src/components/product-card/ProductCardLoader.vue'),
  },
  props: {
    mediaType: {
      type: String,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isAudioLayout() {
      return isProductType('audio', this.mediaType);
    },
  },
};
